// Shortens large numbers for display: 1234 -> "1,234", 12_500_000 -> "12.5m".
//
// Lives on its own rather than inside filters.js because it is pure — no Vue,
// no polyfill — and two callers now need it: the Vue filter registration in
// filters.js, and the report Summary section, which formats outside a template
// and must abbreviate identically to the donut totals it sits under.

function round(n, precision) {
  var prec = Math.pow(10, precision);
  return Math.round(n * prec) / prec;
}

export function abbreviateNumber(n, min = 1000000, precision = 2) {
  if (n < min) {
    return n.toLocaleString();
  }
  var abbrev = "kmb"; // could be an array of strings: [' m', ' Mo', ' Md']
  var pow = Math.pow,
    floor = Math.floor,
    abs = Math.abs,
    log = Math.log;

  var base = floor(log(abs(n)) / log(1000));
  var suffix = abbrev[Math.min(2, base - 1)];
  base = abbrev.indexOf(suffix) + 1;
  return suffix ? round(n / pow(1000, base), precision) + suffix : "" + n;
}

export default abbreviateNumber;
